import { Button, Input, Select } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { errorSwal } from '../../../helper/swalHelpers';
import { checkIsNotEmpty, isNumeric } from '../../../helper/validations';
import { useCategoriasSeccion } from '../../../hooks/Front/formularios/useFormularios';
import { useVehiculos, useVehiculoSlug } from '../../../hooks/Front/mercadoPublico/useMercadoPublico';
import { Label } from '../../views/contactanos/contactanos';
import { LayoutForm } from './flota';

const Mercado = ({ states }) => {
    const { slug, slugversion: cantidadSlug } = useParams();

    const { vehiculo: vehiculoSlug, error: errorVS, isLoading } = useVehiculoSlug(slug);


    const [form, setForm] = useState({
        idCategoria: undefined,
        tipo: 'mercado-publico',
        idModelo: undefined,
        cantidad: 1
    });
    const [vehiculo, setVehiculo] = useState(undefined)


    const { idCategoria, cantidad, idModelo } = form;

    const handleChangeSelects = (name, value) => {
        if (name === 'idCategoria') {
            setForm({ ...form, [name]: value, idModelo: undefined });
            setVehiculo(undefined);
            states.setProducto(undefined);
            return
        }


        let iOf = vehiculos[0].vehiculos.findIndex(v => v.idVehiculo === value)
        const car = vehiculos[0].vehiculos[iOf];
        setForm({ ...form, [name]: value });
        setVehiculo(car);

        states.setProducto({ ...car, tipo: 'mercado-publico', cantidad });
    }

    const handleChangeRestar = () => {
        if (cantidad >= 2) {
            let newCantidad = cantidad - 1;
            setForm({ ...form, cantidad: newCantidad });
            if (vehiculo) states.setProducto({ ...vehiculo, tipo: 'mercado-publico', cantidad: newCantidad });

        }

    }

    const handleChangeSumar = () => {
        if (cantidad < 10) {
            let newCantidad = cantidad + 1;
            setForm({ ...form, cantidad: newCantidad });
            if (vehiculo) states.setProducto({ ...vehiculo, tipo: 'mercado-publico', cantidad: newCantidad });
        }
    };

    const validarForm = () => {
        if (
            !checkIsNotEmpty(idCategoria) ||
            !checkIsNotEmpty(idModelo)
        ) return false;

        return true;
    }

    const handleSubmit = () => {
        if (!validarForm()) {
            errorSwal("Ocurrió un error", "Recuerda ingresar todos los campos requeridos.", "Ok");
            return;
        }
        states.setFormP(form);
        states.setPaso(1);

    }
    const { categorias, loading, error } = useCategoriasSeccion("MERC_PUBLICO");
    const [vehiculos, errorV, loadingV] = useVehiculos(idCategoria);

    useEffect(() => {
        if (vehiculoSlug && errorVS === false && isLoading === false && slug) {
            let dataV = vehiculoSlug.Vehiculo;
            let cantidadS = 1;
            if (isNumeric(cantidadSlug) !== false) {
                console.log("🚀 -> useEffect -> cantidadSlug", cantidadSlug)
                cantidadS = isNumeric(cantidadSlug) <= 10 ? isNumeric(cantidadSlug) : 10;
                console.log("🚀 -> useEffect -> cantidadSlug", cantidadSlug)
                console.log("🚀 -> useEffect -> cantidadSlug", cantidadSlug)
            }

            setForm({ ...form, idCategoria: dataV.idSubCategoria, idModelo: dataV.idVehiculo, cantidad: cantidadS });

            setVehiculo(dataV);

            states.setProducto({ ...dataV, tipo: 'mercado-publico', cantidad: cantidadS });

        }
    }, [vehiculoSlug, errorVS, isLoading, slug, cantidadSlug]);

    const getViewPortWidth = () => {
        let viewportwidth;
        // the more standards compliant browsers (mozilla/netscape/opera/IE7) use window.innerWidth and window.innerHeight
        if (typeof window.innerWidth != 'undefined') {
            viewportwidth = window.innerWidth;
            // IE6 in standards compliant mode (i.e. with a valid doctype as the first line in the document)
        } else
            if (typeof document.documentElement != 'undefined' &&
                typeof document.documentElement.clientWidth != 'undefined' &&
                document.documentElement.clientWidth != 0) {
                viewportwidth = document.documentElement.clientWidth;
                // older versions of IE
            } else {
                viewportwidth = document.getElementsByTagName('body')[0].clientWidth;
            }
        return viewportwidth;
    }

    return (
        <>
            <LayoutForm>
                <p className="bold-title-hyundai mt-4 mb-3">Datos del vehículo</p>
                <Label texto="Categoría" />
                <Select onChange={v => handleChangeSelects("idCategoria", v)} value={idCategoria} className="w-100 hyundai-select" >
                    {categorias && categorias.length > 0 && loading === false && error === false &&
                        categorias.map((categoria, i) =>
                            <Select.Option value={categoria.idCategoria} key={i}>{categoria.Nombre}</Select.Option>
                        )
                    }
                </Select>
            </LayoutForm>

            <LayoutForm>
                <Label texto="Modelo" />
                <Select className="w-100 hyundai-select" onChange={v => handleChangeSelects("idModelo", v)} value={idModelo}>
                    {vehiculos && vehiculos[0] && vehiculos[0].vehiculos && vehiculos[0].vehiculos.length > 0 && loadingV === false && errorV === false &&
                        vehiculos[0].vehiculos.map((vehiculo, i) =>
                            <Select.Option value={vehiculo.idVehiculo} key={i}>{vehiculo.Nombre} - {vehiculo.descripcionCorta}</Select.Option>
                        )
                    }
                </Select>
            </LayoutForm>

            {/* <LayoutForm>
                <Label texto="Cantidad" />
                <button className="btn-unidad-ficha btn-restar" onClick={handleChangeRestar}>-</button>
                <Input className="input-unidad-hyundai" value={cantidad} readOnly />
                <button className="btn-unidad-ficha btn-sumar" onClick={handleChangeSumar}>+</button>
            </LayoutForm> */}

            {/* {
                !idModelo && getViewPortWidth() <= 768
                    ? <div className='h-div-sin-modelo' />
                    : <div className='h-div-con-modelo' />
            } */}

            {
                getViewPortWidth() <= 768 ? (
                    <div className='col-btn-formulario-cotizar mt-3'>
                        <Button
                            className="btn-primario-cotizador font-btn w-100 f-responsive mb-3"
                            onClick={handleSubmit}
                        >
                            Siguiente
                        </Button>
                    </div>
                ) : (
                    <LayoutForm>
                        <Button className="btn-primario font-btn w-100 f-responsive mb-5" onClick={handleSubmit}>Siguiente</Button>
                    </LayoutForm>
                )
            }
        </>
    );
}

export default Mercado;